import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';
import { trustBadges } from '@/mocks/testimonials';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stunning%20editorial%20overhead%20view%20of%20a%20curated%20luxury%20fashion%20marketplace%20table%20with%20premium%20leather%20handbags%20designer%20sunglasses%20silk%20scarves%20and%20gold%20jewelry%20arranged%20in%20an%20artful%20spiral%20pattern%20on%20a%20warm%20terracotta%20marble%20surface%20dramatic%20soft%20natural%20lighting%20from%20above%20warm%20earth%20tones%20and%20cream%20accents%20high%20resolution%20commercial%20luxury%20editorial%20photography%20inviting%20atmosphere&width=1800&height=900&seq=home-hero-v2&orientation=landscape"
        alt="Kakobuy Spreadsheet curated product finds showcase with fashion items and accessories in clean editorial layout"
        title="Kakobuy Spreadsheet Product Finds"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-20 md:py-28">
        <div className="max-w-3xl">
          <span className="inline-block text-xs md:text-sm font-semibold text-background-50/90 uppercase tracking-[0.2em] mb-4 bg-foreground-900/30 backdrop-blur-sm px-4 py-1.5 rounded-full">
            Updated July 2026
          </span>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-background-50 leading-[1.08] mb-6">
            The Ultimate<br />
            <span className="text-primary-300">Kakobuy Spreadsheet</span><br />
            Hub For Smart Shopping
          </h1>
          <p className="text-base md:text-lg text-background-50/85 leading-relaxed max-w-xl mb-8">
            Discover thousands of curated Kakobuy Spreadsheet finds including sneakers, fashion, accessories, and trending products. Compare categories, learn shopping strategies, and access updated product resources in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-4 mb-10">
            <Link
              to="/kakobuy-spreadsheet-guide"
              className="px-7 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              Explore Kakobuy Spreadsheet
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-7 py-3.5 text-sm font-semibold text-background-50 bg-foreground-900/60 backdrop-blur-sm rounded-full hover:bg-foreground-900/80 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2 border border-background-50/20"
            >
              Visit Our Main Shopping Platform
              <i className="ri-external-link-line text-base"></i>
            </a>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-lg">
            {trustBadges.map((badge) => (
              <div
                key={badge.text}
                className="flex items-center gap-2 text-xs text-background-50/80"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${badge.icon} text-sm text-accent-300`}></i>
                </span>
                <span className="whitespace-nowrap">{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}